export default __webpack_public_path__ + "static/media/file-document-box-search-outline.73613a50.svg";